import { useEffect } from "react";

// Persist which booking drawer is open in the URL (?drawer=<lineId>) so a full page reload (Ctrl+R /
// F5) reopens the same booking. Uses history.replaceState — no Inertia visit, no history spam.
const PARAM = "drawer";

export const readDrawerLineId = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return new URLSearchParams(window.location.search).get(PARAM) || null;
};

export const useDrawerUrlSync = (drawerLineId) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const url = new URL(window.location.href);
    if (drawerLineId) {
      url.searchParams.set(PARAM, drawerLineId);
    } else {
      url.searchParams.delete(PARAM);
    }
    window.history.replaceState(window.history.state, "", url);
  }, [drawerLineId]);
};
